import { reactive } from 'vue'
import { AuthService } from '@/services/auth'
import { PaymentsService } from '@/services/payments'

export const authStore = reactive({
  user: AuthService.getUserData(),
  isAuthenticated: AuthService.isAuthenticated(),
  credits: 0,
  creditsLoading: false,
  appointmentMode: false,
  restaurantMode: false,
  subscriptionExpired: false,
  subscriptionChecked: false,
  subscriptionChecking: false,
  subscription: null, // Store full subscription data including plan_id

  setUser (userData) {
    this.user = userData
    this.isAuthenticated = true
  },

  clearUser () {
    this.user = null
    this.isAuthenticated = false
    this.credits = 0
    this.appointmentMode = false
    this.restaurantMode = false
    this.subscriptionExpired = false
    this.subscriptionChecked = false
    this.subscription = null
    AuthService.logout()
  },

  setAppointmentMode (isAppointmentMode) {
    this.appointmentMode = isAppointmentMode
  },

  setRestaurantMode (isRestaurantMode) {
    this.restaurantMode = isRestaurantMode
  },

  async login (credentials) {
    const response = await AuthService.login(credentials)
    AuthService.setAuthData(response)
    this.setUser(response.user)
    // Reset subscription cache for fresh check after login
    this.subscriptionExpired = false
    this.subscriptionChecked = false
    // Load credits after successful login
    this.loadCredits()
    return response
  },

  logout () {
    this.clearUser()
  },

  async loadCredits () {
    this.creditsLoading = true
    try {
      const creditsData = await AuthService.getUserCredits()
      this.credits = creditsData.credits || 0
    } catch (error) {
      console.error('Failed to load credits:', error)
      this.credits = 0
    } finally {
      this.creditsLoading = false
    }
  },

  async checkSubscription () {
    if (this.subscriptionChecking) return
    this.subscriptionChecking = true
    try {
      const result = await PaymentsService.getSubscriptionStatus()
      this.subscriptionExpired = result.success === false
      this.subscription = result.subscription || null
      this.subscriptionChecked = true
    } catch (error) {
      console.error('Failed to check subscription:', error)
    } finally {
      this.subscriptionChecking = false
    }
  },

  // Check if user has access to WhatsApp Broadcast (plan_id not 4 or 5)
  canAccessBroadcast () {
    if (!this.subscription || !this.subscription.plan_id) return false
    const planId = this.subscription.plan_id
    // Block plans 4 and 5
    return planId !== 4 && planId !== 5
  }
})
